const state = {
  objects: []
}

const getters = {
  GET_OVERVIEW (state) {
    return state.objects
  }
}

const mutations = {
  SET_OVERVIEW (state, obj) {
    state.objects = obj
    // console.log(state.objects)
  },
  SET_OVERVIEW_OBJECT (state, obj) {
    console.log(obj)
    state.objects[obj.index] = obj.data
  },
  SET_OVERVIEW_ADDOBJECT (state, obj) {
    let x = state.objects
    x.push({})
    state.objects = x
    // console.log(state.objects)
  },
  DELETE_OVERVIEW_OBJECT (state, index) {
    state.objects.splice(index, 1)
  }
  // SET_OVERVIEW_OBJECT (state, obj) {
  //   let x = state.objects
  //   for (let i = 0; i < obj; i++) {
  //     x.push({})
  //   }
  //   state.objects = x
  //   console.log(state.objects)
  // }
}

const actions = {
  LOAD_OVERVIEW_OBJECT ({commit}, obj) {
    // console.log(obj)
    if (obj.length > 0) {
      // console.log('既存')
      commit('SET_OVERVIEW', obj)
    }
  },
  SAVE_OVERVIEW_OBJECT ({commit}, obj) {
    let objects = {
      index: obj.index,
      data: obj.data
    }
    commit('SET_OVERVIEW_OBJECT', objects)
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/overview.js